<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useAuthStore } from "~/store/auth/auth.store";
import { useFormats } from "~/composables/utils/useFormat";
import { useRequests } from "~/composables/requests/useRequests";
import StatusTag from "~/components/Common/StatusTag.vue";
import { useSessionIndividual } from "~/composables/sessions/useSessionIndividual";

const authStore = useAuthStore();
const formats = useFormats();
const requests = useRequests();
const sessionIndividual = useSessionIndividual();
const requestInfo = ref();

onMounted(async () => {
  if (sessionIndividual.sourceType.value) {
    requestInfo.value = await sessionIndividual.getRequestInfos(sessionIndividual.sourceType.value);
  }
});
</script>

<template>
  <div class="session_user_info__container">
    <div class="flex items-center justify-between">
      <h3 class="heading_3_demi text-primary-color p-[8px]">Infos demande</h3>
    </div>
    <div v-if="requestInfo?.requestId" class="session_user_info__grid">
      <div class="flex items-center justify-between">
        <section v-if="requestInfo?.createdAt" class="flex items-center gap-1">
          <SvgIcon name="calendar-menu" class="w-[16px] h-[16px] text-secondary-color"></SvgIcon>
          <div class="flex gap-1">
            <span class="text-secondary-color">Demandée le </span>
            <span class="truncate text-secondary-color">{{
              formats.toDateDisplayLocal(requestInfo?.createdAt) ?? "-"
            }}</span>
          </div>
        </section>
        <section v-if="requestInfo?.status" class="flex items-center gap-2">
          <StatusTag :tag="requests.statusMapping(requestInfo?.status)" />
          <div
            v-if="(authStore.isCompanyAdmin || authStore.isGroupAdmin) && requestInfo"
            class="cursor-pointer button_secondary_default text-primary-blue-color"
            @click="navigateTo(`/requests/${requestInfo?.requestId}`, { open: { target: '_blank' } })"
          >
            <SvgIcon name="link" class="w-[16px] h-[16px]"></SvgIcon>
          </div>
        </section>
      </div>
      <section v-if="requestInfo?.managerPriority" class="flex items-center gap-1">
        <SvgIcon name="pen" class="w-[16px] h-[16px] text-secondary-color"></SvgIcon>
        <span class="text-secondary-color">Priorité :</span>
        <span class="truncate text-secondary-color">{{ requestInfo?.managerPriority ?? "-" }}</span>
      </section>
    </div>
    <div v-else class="empty_state">
      <SvgIcon name="request-menu" class="w-[16px] h-[16px] text-secondary-color"></SvgIcon>
      <span class="body_regular text-secondary-color">Cette inscription n’est pas liée à une demande</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "assets/scss/texts";

.session_user_info__container {
  @apply pt-[8px];
  border-bottom: 1px solid var(--grey-lightest);
}

.session_user_info__grid {
  @apply flex flex-col gap-[8px] p-4 mb-[32px] mt-[16px] mx-2;
  border: 1px solid var(--grey-lightest);
  border-radius: 8px;

  section {
    @apply inline-flex body_regular items-center;
  }
}

.empty_state {
  @apply flex items-center gap-2 p-8 mb-[32px] mt-[16px] mx-2 border rounded-lg text-secondary-color justify-center;
  border: 1px solid var(--grey-lightest);
}
</style>
